// In preparation for some future suspense support react-router isn't exposing history any longer. Since we want to be
// able to navigate outside our component code, we are exposing this navigate fn for use e.g. in the URL-service. As
// soon as react router implements a solution for this, we can get rid of this hook.
// https://github.com/remix-run/react-router/pull/8284#issuecomment-963711722
import { useNavigate } from 'react-router-dom';

export const externalHistory: { navigate: (path: string, options?: Record<'replace', boolean>) => void } = {} as any;

export const useExposeNavigate = () => {
    externalHistory.navigate = useNavigate();
};
